<template>
  <section id="faq" class="bg-[#f3f4ff] pt-20 lg:pt-[120px] pb-12 lg:pb-[90px] relative z-20 overflow-hidden">
    <div class="container">
      <div class="flex flex-wrap -mx-4">
        <div class="w-full px-4">
          <div class="text-center mx-auto mb-[60px] lg:mb-20 max-w-[620px]">
            <span class="font-semibold text-lg text-primary mb-2 block"> FAQ </span>
            <h2 class="font-bold text-3xl sm:text-4xl md:text-[42px] text-dark mb-4">
              Questions, Doutes?
            </h2>
            <p class="text-lg sm:text-xl leading-relaxed sm:leading-relaxed text-body-color">
            </p>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap -mx-4">
        <div class="w-full lg:w-1/2 px-4">
          <div v-for="(question, index) in faqs.slice(0, 2)" :key="index"
            class="single-faq w-full bg-white border border-[#F3F4FE] rounded-lg p-5 sm:p-8 mb-8 wow fadeInUp"
            data-wow-delay=".1s">
            <button @click.stop="toggleState($event)" class="faq-btn flex items-center w-full text-left">
              <div class="w-full max-w-[40px] h-10 flex items-center justify-center rounded-lg text-primary bg-opacity-5 mr-5">
                <svg width="17" height="10" viewBox="0 0 17 10" class="fill-current icon">
                  <path
                    d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                    fill="#3056D3"
                    stroke="#3056D3"
                  />
                </svg>
              </div>
              <div class="w-full">
                <h4 v-html="question.formulation" class="text-base sm:text-lg font-semibold text-black"></h4>
              </div>
            </button>
            <div class="faq-content mx-8 h-0">
              <p class="text-base text-body-color text-justify leading-relaxed py-3" v-html="question.answer"></p>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 px-4">
          <div v-for="(question, index) in faqs.slice(2, 4)" :key="index"
            class="single-faq w-full bg-white border border-[#F3F4FE] rounded-lg p-5 sm:p-8 mb-8 wow fadeInUp"
            data-wow-delay=".1s">
            <button @click.stop="toggleState($event)" class="faq-btn flex items-center w-full text-left">
              <div class="w-full max-w-[40px] h-10 flex items-center justify-center rounded-lg text-primary bg-opacity-5 mr-5">
                <svg width="17" height="10" viewBox="0 0 17 10" class="fill-current icon">
                  <path
                    d="M7.28687 8.43257L7.28679 8.43265L7.29496 8.43985C7.62576 8.73124 8.02464 8.86001 8.41472 8.86001C8.83092 8.86001 9.22376 8.69083 9.53447 8.41713L9.53454 8.41721L9.54184 8.41052L15.7631 2.70784L15.7691 2.70231L15.7749 2.69659C16.0981 2.38028 16.1985 1.80579 15.7981 1.41393C15.4803 1.1028 14.9167 1.00854 14.5249 1.38489L8.41472 7.00806L2.29995 1.38063L2.29151 1.37286L2.28271 1.36548C1.93092 1.07036 1.38469 1.06804 1.03129 1.41393L1.01755 1.42738L1.00488 1.44184C0.69687 1.79355 0.695778 2.34549 1.0545 2.69659L1.05999 2.70196L1.06565 2.70717L7.28687 8.43257Z"
                    fill="#3056D3"
                    stroke="#3056D3"
                  />
                </svg>
              </div>
              <div class="w-full">
                <h4 v-html="question.formulation" class="text-base sm:text-lg font-semibold text-black"></h4>
              </div>
            </button>
            <div class="faq-content mx-8 h-0">
              <p class="text-base text-body-color text-justify leading-relaxed py-3" v-html="question.answer"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Faq",
  data() {
    return {
      faqs: [
        {
          formulation: "Quand est-ce que la saison de service débute?",
          answer: "La saison débute dès le mois d\'avril et se termine vers la fin du mois de septembre afin de laisser le temps à vos haies de s\'adapter aux froids hivernaux. Grâce à nos équipement sécialisés, nos tailleurs effectuent des coupes de qualité qui accentue la cicatrisation et la repousse de vos haies de cèdres. De cette manière, la coupe aura aussi l\'avantage de fournir l\'énergie nécessaire à votre haie pour la faire continuer de croître naturellement."
        },
        {
          formulation: "Combien coupez-vous de la haie de cèdre?",
          answer: "Lors de nos tailles, nous ne coupons jamais plus du tiers/plus de la moitié de la nouvelle repousse de l\'année.  Une coupe trop sévère, mal effectuée ou non entretenue pourrait provoquer des dégats à long terme. Exemple: des cimes dénudées, des trous majeurs dans les haies ou des troncs qui prennent le dessus sur leur feuillage. C\'est entre autre pour cela qu\'il est grandement important d\'effectuer une coupe annuelle. Nous offrons également le service de retrait, d\'installation et de plantation de haie de cèdres dans le secteur de la rive nord."
        },
        {
          formulation: "Ramassez-vous les retailles?",
          answer: "Chaque fois qu\'un travail est complété, nous prenons en charge la ramasse des retailles de haies de cèdres ainsi que l\'extraction de celle-ci par l\'entremise de compagnie spécialisée en production d\'huile essentielle et de parfum de cèdre. Nous recommandons lors des grandes chaleurs de garder le plus possible un sol humide au pied de vos haies de cèdres afin d\'éviter une sécheresse. Il est important de faire de même pour les jeunes haies en pleine croissance. Sans oublier d\'arosser à l\'automne afin de minimiser le stress de dessiccation hivernale (air sec et froid de l\'hiver qui provoquent un désechement)."
        },
        {
          formulation: "Sur quelles variétés de cèdre offrez-vous vos services?",
          answer: `Une taille adaptée à n\'importe quelle variété de cèdres. Que vous ayez un :  
                  <ul>
                    <li>Thuya Accidentalis</li>
                    <li>Nigara</li>
                    <li>Brandon</li>
                    <li>Fastigiata</li>
                  </ul>
                    de n\'importe quelle hauteur, la taille de haie doit se réaliser de manière annuelle
                    et de forme arrondie au sommet. Cela permettra d\'éviter un étiolement des branches
                    et de favoriser la densité du feuillage ainsi que de procurer un ensoleillement optimal.
                    De cette manière, vous trouverez l\'intimité recherchée chez vous!
                  `
        }
      ]
    }
  },
  methods: {
    toggleState(event) {
      if (event) {
        const elem = event.currentTarget.parentElement;
        elem.querySelector(".icon").classList.toggle("rotate-180");
        elem.querySelector(".faq-content").classList.toggle("h-0");
      }
    }
  }
};
</script>

<style lang="scss">
#faq {
  background: linear-gradient(180deg, #ffffff 0%, #03985f 66%, #212b36 100%);
}

.faq-content {
  transition: max-height ease-in-out .3s;
  max-height: 30rem;
  overflow: hidden;

  p ul {
    margin-bottom: 0.5rem;

    li {
      list-style: disc;
      margin-left: 4rem;
    }
  }

  &.h-0 {
    max-height: 0;
  }
}
</style>
